<template>
    <ui-modal
        dismiss-on="close-button esc"
        ref="modal"
        size="medium"
        title="Compose Message"
        class="new-message-modal"
        @hide="hidden"
    >
        <template v-if="!hasNoMessageBoxes">
            <message-list-status-toggle
                style="margin-bottom: 1rem;"
                :value="selectedMessageType"
                @input="opt => { this.switchMessageType(opt.value); }"
                :options="messageTypes"
            />

            <compose-email-pane
                ref="messagePane"
                :message-defaults="messageDefaults"
                @sent="e => { $refs.modal.close(); $emit('sent', e) }"
                v-if="isOpen && selectedMessageType === 'email'"
            />

            <compose-text-pane
                ref="messagePane"
                :message-defaults="messageDefaults"
                @sent="e => { $refs.modal.close(); $emit('sent', e) }"
                v-if="isOpen && selectedMessageType === 'text'"
            />

            <compose-whats-app-pane
                ref="messagePane"
                :message-defaults="messageDefaults"
                @sent="e => { $refs.modal.close(); $emit('sent', e) }"
                v-if="isOpen && selectedMessageType === 'whatsapp'"
            />
        </template>

        <hero-error-message
            v-else
            title="You don't have access to a message box"
            detail="You need to be added to a message box before you can send messages. Please contact your administrator."
        />
    </ui-modal>
</template>

<script>
    import ComposeTextPane from "./ComposeTextPane";
    import ComposeEmailPane from "./ComposeEmailPane";
    import MessageListStatusToggle from "./MessageListStatusToggle";
    import { MessageTypeList } from "../../classes/Api/Inbox";
    import {isEmpty} from "lodash";
    import ComposeWhatsAppPane from "./ComposeWhatsAppPane.vue";

    export default {
        components: {ComposeWhatsAppPane, ComposeTextPane, MessageListStatusToggle, ComposeEmailPane},
        data() {
            return {
                selectedMessageType: '',
                defaultMessageBox: {},
                isOpen: false,
                messageDefaults: {},
            }
        },
        props: {
            to: {
                type: Object,
                default() {
                    return {}
                }
            }
        },
        created() {
            this.resetMessageDefaults()
        },
        computed: {
            hasNoMessageBoxes() {
                return this.$store.getters['inbox/messageBoxes/loaded']
                    && this.$store.getters['inbox/messageBoxes/all'].length === 0
            },
            messageTypes() {
                let types = MessageTypeList
                const allowedTypes = window.marque.ui.features.crm.channels
                return types.filter(t => allowedTypes[t.value] && allowedTypes[t.value].enabled)
            }
        },
        methods: {
            open() {
                this.isOpen = true

                if (this.$route && this.$route.params.message_box_id) {
                    this.defaultMessageBox = this.$store.getters['inbox/messageBoxes/all'].find(
                        i => i.id == this.$route.params.message_box_id
                    )

                    this.switchMessageType('email')
                }

                if (isEmpty(this.defaultMessageBox)) {
                    this.$store.dispatch('inbox/messageBoxes/getOrLoad').then(r => {
                        this.defaultMessageBox = this.$store.getters['inbox/messageBoxes/first'];

                        this.switchMessageType('email')
                    })
                }

                this.$refs.modal.open()
            },
            switchMessageType(type) {
                this.selectedMessageType = type

                this.messageDefaults.message_box = this.defaultMessageBox

                this.$nextTick(() => {
                    if (this.$refs.messagePane) {
                        this.$refs.messagePane.reset()
                    }
                })
            },
            hidden() {
                this.isOpen = false

                this.reset()
            },
            reset() {
                this.resetMessageDefaults()

                this.switchMessageType('email')
            },
            resetMessageDefaults() {
                this.messageDefaults = {
                    to: this.to,
                    from: {},
                    subject: '',
                    content: '',
                    message_box: {},
                    attachments: [],
                }
            },
            mergeMessageDefaults(defaults) {
                this.messageDefaults = Object.assign(this.messageDefaults, defaults)
            }
        },

    }
</script>

<style lang="scss">
.new-message-modal {
    .message-quill-editor {
        .ql-container .ql-editor {
            min-height: 200px;
        }
    }

    &.ui-modal--size-medium {
        .ui-modal__container {
            width: 43rem;
        }
    }
}
</style>